class CartUpsells extends HTMLElement {
  static requests = new Map();

  connectedCallback() {
    this.addEventListener('click', this.onClick);
    if (!this.dataset.recommendationsUrl) return;
    this.drawer = this.closest('cart-drawer');
    if (!this.drawer) return;
    this.observer = new MutationObserver(() => this.loadRecommendations());
    this.observer.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
    this.loadRecommendations();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.removeEventListener('click', this.onClick);
  }

  async loadRecommendations() {
    if (this.started || !this.drawer.classList.contains('active')) return;
    this.started = true;
    this.observer?.disconnect();
    const url = this.dataset.recommendationsUrl;
    const key = `${url}|${this.dataset.cartSignature}`;
    const cached = CartUpsells.requests.get(key);
    let request = cached?.expires > Date.now() ? cached.promise : null;
    if (!request) {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 6000);
      request = fetch(url, { signal: controller.signal })
        .then((response) => {
          if (!response.ok) throw new Error('Recommendations unavailable');
          return response.text();
        })
        .catch(() => '')
        .finally(() => clearTimeout(timeout));
      if (CartUpsells.requests.size >= 5) CartUpsells.requests.delete(CartUpsells.requests.keys().next().value);
      CartUpsells.requests.set(key, { promise: request, expires: Date.now() + 60000 });
    }
    const html = await request;
    if (!this.isConnected) return;
    const results = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-upsell-results]');
    if (!results?.querySelector('.cart-upsells__item')) return;
    this.innerHTML = results.innerHTML;
    this.hidden = false;
  }

  onClick(event) {
    const opener = event.target.closest('[data-cart-upsell-choose]');
    if (!opener || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const modal = document.getElementById('CartUpsellModal');
    if (!modal?.show) return;
    event.preventDefault();
    if (opener.getAttribute('aria-disabled') === 'true') return;
    modal.show(opener);
  }
}

customElements.define('cart-upsells', CartUpsells);
